module.exports = __webpack_public_path__ + "static/media/arrow-left-solid.edac5739.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/arrow-left-solid.svg
// module id = 669
// module chunks = 2